<template>
  <div class="form-group" :class="classFormGroup">
    <label v-if="label" style="width: 100%">{{ label }}
      <span v-if="required" style="color: red;"> *</span>
      <span v-if="conditionalRequired" style="color: blue;"> *</span>
      <br>
      <span v-if="validation?.$error" style="color: red;">{{ messages }}</span>
      <span v-if="validationMessage" style="color: red;">{{ validationMessage }}</span>
    </label>
    <div v-if="isCurrency"
         class="d-flex form-control p-0 overflow-hidden"
         :class="{ 'is-invalid': validation?.$error }">

      <div class="font-weight-bold rounded-0 w-100 h-100 form-control border-top-0 border-bottom-0 border-left-0"
           style="background-color: #e9ecef; max-width: 35px;">€
      </div>
      <input
          :type="type"
          :value="modelValue"
          :disabled="disabled"
          @input="handleInput"
          v-bind="$attrs"
          :style="inputStyle"
          :placeholder="placeholder"
          :step="type === 'number' ? `0.${'1'.padEnd(decimalPlaces, '0')}` : null"
          class="h-100 w-auto border-0 pl-2 form-control">
    </div>
    <input v-if="!isCurrency"
           :type="type"
           :value="modelValue"
           :disabled="disabled"
           @input="handleInput"
           v-bind="$attrs"
           :style="inputStyle"
           :placeholder="placeholder"
           :autocomplete="autocomplete"
           :name="nameForAutocomplete"
           :step="type === 'number' ? `0.${'1'.padEnd(decimalPlaces, '0')}` : null"
           class="form-control"
           :class="{ 'is-invalid': validation?.$error }">
  </div>
</template>

<script setup>
import { defineEmits, defineProps, toRefs } from 'vue';

const props = defineProps({
  modelValue: {
    type: [ String, Number, null ],
    required: true,
  },
  label: {
    type: [ String, Boolean ],
    default: false,
  },
  placeholder: {
    type: [ String, Boolean ],
    default: '',
  },
  disabled: {
    type: [ Boolean ],
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  conditionalRequired: {
    type: Boolean,
    default: false,
  },
  classFormGroup: {
    type: String,
    default: '',
  },
  isCurrency: {
    type: Boolean,
    default: false,
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: 'text',
  },
  messages: {
    type: [ Object, String, Array ],
    default: () => ({}),
  },
  validationMessage: {
    type: [ String, null ],
    default: '',
  },
  refProps: {
    type: [ Object, String ],
    default: () => ({}),
  },
  decimalPlaces: {
    type: Number,
    default: 0, // Default to 2 decimal places
  },
  inputStyle: {
    type: Object,
  },
  autocomplete: {
    type: String,
    default: 'off',
  },
  nameForAutocomplete: {
    type: String,
    default: 'name',
  },
});

const emit                 = defineEmits([ 'update:modelValue' ]);
const { modelValue, type } = toRefs(props);

const handleInput = (event) => {
  let inputValue = event.target.value;

  if (type.value === 'number') {
    inputValue                         = inputValue.replace(/[^0-9.]/g, ''); // Removes non-numeric characters except `.`
    const [ integerPart, decimalPart ] = inputValue.split('.');

    if (decimalPart && decimalPart.length > props.decimalPlaces) {
      inputValue         = +`${integerPart}.${decimalPart.slice(0, props.decimalPlaces)}`;
      event.target.value = +inputValue;
    } else {
      emit('update:modelValue', +inputValue);
    }
  } else {
    emit('update:modelValue', inputValue);
  }
};

</script>

<style scoped>

</style>